export function checkValidEmail(email) {
  const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  return regex.test(email)
}

export function filterEmail(value) {
  const allowedChars = /^[a-zA-Z0-9@._+-]*$/;

  // Check if the input contains any special characters
  return allowedChars.test(value);
}



// WEBPACK FOOTER //
// ./src/helpers/email.js